/* src/app/private/modules/tickets/tickets.component.scss */
#container-div {
  height: 80vh;
  position: sticky;
  top: 0;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.amazon-connect-wrapper {
  height: 600px;
  width: 400px;
}
.tab-container {
  display: flex;
  gap: 5px 15px;
  flex-wrap: wrap;
  overflow-x: auto;
}
.tab-container::-webkit-scrollbar {
  display: none;
}
.tab {
  padding: 7px 28px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid #FFFFFF;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2509803922) inset;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  font-weight: 600;
  border-bottom-width: 2px !important;
  border-bottom-color: rgba(0, 0, 0, 0.214);
  height: 100%;
  width: max-content;
}
.outer-tab {
  border: 1px solid #FFFFFF;
  border-width: 1px 1px 1px 0px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  border-bottom-width: 0px !important;
}
.active {
  border-width: 1px 1px 1px 5px;
  border-style: solid;
  border-color: #F0950C;
  font-weight: bold;
  box-shadow: none !important;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.priority-box {
  padding: 6px 24px;
  border-radius: 50px;
  font-weight: 600;
  color: #525252;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.low {
  background-color: #B3FDC0;
}
.medium {
  background-color: #FDE0B3;
}
.high {
  background-color: #FDC0C0;
}
.info-circle-icon {
  background-color: var(--secondary-light-primary);
  color: #FFFFFF;
  border-radius: 50%;
  font-size: 18px;
}
/*# sourceMappingURL=tickets.component.css.map */
